import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiInstagram, FiMail, FiHeart } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-950 border-t border-slate-900 mt-20">
      <div className="max-w-5xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/00f9785630fa510c7b7249771f188009b71ad762fbad38d2b89b3733d51394c2722890c07f10237a0b5d877487ecaead/images/aW1hZ2UvcG5n/b347cf89d959987cc22861640fd38b47.png" 
                alt="Bat Coffee Logo" 
                className="w-10 h-10 object-contain"
              />
              <span className="text-xl font-bold text-white uppercase tracking-tighter">Bat Coffee</span>
            </div>
            <p className="text-sm text-slate-500 leading-relaxed">
              Elevating the commercial and home brewing experience through data-driven precision and premium roasting.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-bold text-white uppercase tracking-widest">Resources</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><a href="https://batcoffee.com" target="_blank" rel="noopener noreferrer" className="hover:text-yellow-500 transition-colors">Official Website</a></li>
              <li><a href="#" className="hover:text-yellow-500 transition-colors">Brewing Guides</a></li>
              <li><a href="mailto:coffee@batcoffee.com" className="hover:text-yellow-500 transition-colors">Wholesale Inquiry</a></li>
            </ul>
          </div>

          <div className="space-y-4">
            <h4 className="text-sm font-bold text-white uppercase tracking-widest">Connect</h4>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/batcoffee1/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center text-slate-400 hover:bg-yellow-500 hover:text-slate-950 transition-all"
              >
                <SafeIcon icon={FiInstagram} />
              </a>
              <a 
                href="mailto:coffee@batcoffee.com" 
                className="w-10 h-10 rounded-full bg-slate-900 flex items-center justify-center text-slate-400 hover:bg-yellow-500 hover:text-slate-950 transition-all"
              >
                <SafeIcon icon={FiMail} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-900 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-slate-600 font-medium uppercase tracking-widest">
          <p>© {currentYear} Bat Coffee Co. All rights reserved.</p>
          <p className="flex items-center gap-1">
            Created with <SafeIcon icon={FiHeart} className="text-red-900" /> for the coffee community
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;